import { useSortable } from '@dnd-kit/react/sortable';
import classNames from 'classnames';
import { DnDField } from 'routes/essential-workspace/components/right-panel/draggable-list/draggable-lists';
import { LayoutFieldListItem } from 'routes/essential-workspace/components/right-panel/draggable-list/layout-list-item';
import { FieldId } from 'routes/essential-workspace/state/model';
import { Width } from 'state/product-description/types';
export type PinState = 'disabled' | 'inactive' | 'active';
type DraggableListItemProps = {
  field: DnDField;
  pinState: PinState;
  isDraggable: boolean;
  disabledPinVariant?: 'filled' | 'outlined';
  index: number;
  onTogglePin?: (fieldId: FieldId) => void;
  onUpdateWidth?: (fieldId: FieldId, width: Width) => void;
  draggableGroup: string;
  className: string;
  showForbiddenTooltip?: boolean;
  forbiddenTooltipTrigger?: number;
};

export function DraggableListItem({
  field,
  pinState,
  isDraggable,
  index,
  draggableGroup,
  disabledPinVariant = 'filled',
  onTogglePin,
  onUpdateWidth,
  className,
  showForbiddenTooltip,
  forbiddenTooltipTrigger,
}: DraggableListItemProps) {
  const { ref, isDragging, handleRef } = useSortable({
    id: field.id,
    index: index,
    type: 'field',
    accept: 'field',
    group: draggableGroup,
    disabled: !isDraggable,

    // The 'move' utility function re-create the items between list, so we can't rely on 'initialGroup' or 'group' properties
    // the only source of truth wich persist is the data property
    data: {
      isAlwaysVisible: field.isAlwaysVisible,
      // adding parent list in property bag because the 'useSortable' set the listitem as the target of the dnd operation in priority
      container: draggableGroup,
    },
  });

  const listItemClassName = classNames(className, isDraggable ? 'shadow-sm' : 'shadow-none');

  return (
    <li className={classNames(listItemClassName)} ref={ref} data-dragging={isDragging}>
      <LayoutFieldListItem
        field={field}
        handleRef={handleRef}
        pinState={pinState}
        isDraggable={isDraggable}
        onTogglePin={onTogglePin}
        onUpdateWidth={onUpdateWidth}
        disabledPinVariant={disabledPinVariant}
        showForbiddenTooltip={showForbiddenTooltip}
        forbiddenTooltipTrigger={forbiddenTooltipTrigger}
      />
    </li>
  );
}
